
import React, { Component } from 'react';
import moment from 'moment';
import '@progress/kendo-theme-default/dist/all.css';
import { Grid, GridToolbar, GridColumn } from '@progress/kendo-react-grid';
import { filterBy } from '@progress/kendo-data-query';
import { orderBy } from '@progress/kendo-data-query';
import { ExcelExport } from '@progress/kendo-react-excel-export';

class BuildingsKendo extends Component {


    constructor(props) {
        super(props)
        this.state = {
            data: [...props.buildings],
            filter: undefined,
            sort: undefined,
            skip: 0,
            take: 10
            //sort: [{ field: 'depth', dir: 'desc' }]
        }
    }


    //shouldComponentUpdate(nextProps, nextState) {
    //    const buildingPropsChange = this.props.buildings !== nextProps.buildings;
    //    const dataStateChange = this.state.data !== nextState.data;
    //    const filterStateChange = this.state.filter !== nextState.filter;
    //    const sortStateChange = this.state.sort!== nextState.sort;
    //    const skipStateChange = this.state.skip !== nextState.skip;

    //    return dataStateChange || filterStateChange || sortStateChange || skipStateChange;
    //}

    filterChange = (event) => {
        this.setState({
            data: filterBy(this.props.buildings, event.filter),
            filter: event.filter
        });
    }

    sortChange = (event) => {
        this.setState({
            data: orderBy(this.props.buildings, event.sort),
            sort: event.sort
        });
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }
// used to be 16
    goToBuilding = (event) => {
        this.props.setCenterAndZoom([event.dataItem.longitude, event.dataItem.latitude], 19);
        this.props.setBuildingMarker([event.dataItem.longitude, event.dataItem.latitude]);
    }

    _export;
    export = () => {
        this._export.save();
    }

    // onRowClick={() => this.props.setCenterAndZoom([150.644, -34.397], 14)}   

    //<GridColumn field="critical" title="Critical" filter="boolean" width="100px" />
    //<GridColumn field="criticalType" title="Info" />
    render() {
        return (
            <div className="App">
                <ExcelExport
                    data={this.props.buildings}
                    ref={exporter => this._export = exporter}
                    fileName={"Building_Impacts_" + moment().format('MMMDYYYY_h:mm_a')}
            >
                    <GridToolbar>
                        <button
                            title="Export to Excel"
                            className="k-button k-primary"
                            onClick={this.export}
                        >
                            Export to Excel
                        </button>
                    </GridToolbar>
                    <Grid
                        style={{ height: '300px' }}
                        data={this.state.data.slice(this.state.skip, this.state.take + this.state.skip)}
                        skip={this.state.skip}
                        take={this.state.take}
                        total={this.state.data.length}
                        pageable={true}
                        onPageChange={this.pageChange}
                        sortable={true}
                        sort={this.state.sort}
                        onSortChange={this.sortChange}
                        filterable={true}
                        filter={this.state.filter}
                        onFilterChange={this.filterChange}
                        onRowClick={this.goToBuilding}              
                    >
                        <GridColumn field="address" title="Address" />
                        <GridColumn field="bldgName" title="Critical Building Name" filterable={false}  />
                        <GridColumn field="occTypGen" title="Building Type"  />
                        <GridColumn field="depth" title="Estimated Flood Depth (ft)" filterable={false}  />
                        <GridColumn field="ffe" title="First Floor Estimation (ft)" filterable={false}  />
                    </Grid>
                </ExcelExport>
            </div>
        );
    }
}

export default BuildingsKendo;



// WEBPACK FOOTER //
// ./src/components/BuildingsGridKendo2/index.js